module.exports = __webpack_public_path__ + "img/3.05.thmb.b0db9eeb.jpg";